import { render, staticRenderFns } from "./Bilhetagem.vue?vue&type=template&id=a12828b0&scoped=true&"
import script from "./Bilhetagem.vue?vue&type=script&lang=js&"
export * from "./Bilhetagem.vue?vue&type=script&lang=js&"
import style0 from "./Bilhetagem.vue?vue&type=style&index=0&id=a12828b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12828b0",
  null
  
)

export default component.exports